import { IUser } from '@app/core';

export enum GameType {
  TEMP,
  AUTO,
  COMP,
  QUIZ,
}

export enum GameStatus {
  PENDING,
  PUBLISHED,
  UNPUBLISHED,
  WARMEDUP,
}

export interface IGame {
  id: number;
  period: number;
  name: string;
  type: GameType;
  isAssign: boolean;
  isLocked: number;
  status: GameStatus;
  dateStart: string;
  dateStop: string;
  lastUpdate: string;
  owner: IUser;
  iconfile: string;
  isSimulating: boolean;
  visible: boolean;
}
